<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <div  class="title" style="background: #fff">补签审批</div>
        <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
            <el-col class="flex-box al-c" :span="4">
                <el-button type="primary" @click="initPage">查询</el-button>
                <el-button type="primary" :disabled="selectList.length == '0'" @click="setStatus('1')">审批</el-button>
                <el-button type="primary" :disabled="selectList.length == '0'" @click="setStatus('2')">驳回</el-button>
            </el-col>
        </Sift>

        <div class="table-con">
            <el-table
                    class="w100 mt20 table"
                    header-row-class-name="table-head"
                    @selection-change="handleSelectionChange"
                      row-class-name="cu-p"
                    stripe :data="list">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="grade" label="年级"></el-table-column>
                <el-table-column align="center" prop="adminclassname" label="班级"></el-table-column>
                <el-table-column align="center" prop="userName" label="学生姓名"></el-table-column>
                <el-table-column align="center" prop="courseName" label="课程名称"></el-table-column>
                <el-table-column align="center" prop="teachers" label="任课教师"></el-table-column>
                <el-table-column align="center" prop="date" label="上课日期"></el-table-column>
                <el-table-column align="center" prop="knob" label="上课节次"></el-table-column>
                <el-table-column align="center" prop="attendanceTime" label="补签时间"></el-table-column>
                <el-table-column align="center" prop="remark" label="原因"></el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>

    </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import { getNoticeList, handleNoticeDelete} from '@/api/managementCenter/notification';
    import { getSupList, setSupStatus} from '@/api/overseasChinese/overseasChinese';

    export default {
        name: "SupplementaryApproval",
        components: {
            Sift
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData : [
                    {
                        type: "text",
                        key: "className",
                        label: "班级名称",
                        placeholder: "请输入班级名称",
                        default: ""
                    },
                    {
                        type: "text",
                        key: "name",
                        label: "姓名",
                        placeholder: "请输入姓名",
                        default: ""
                    },
                ],
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    name:'',
                    className:'',
                    type:0,
                },
                total: 0,
                selectList:[]
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
        },
        methods: {
            setStatus(status){
                let params = {
                        idList: this.selectList || [],
                        type: status
                }
                setSupStatus(params).then((res) =>{
                    if(res.data.code == '0'){
                        this.$message.success( "操作成功!");
                        this.getListFn()
                    }else {
                        this.$message.warning(res.data.msg||"操作失败!" );
                    }
                }).catch(() => {
                    this.$message.error("服务异常" );
                });
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getSupList(this.paramSearch).then((res)=> {
                    this.loading = false;
                    if(res.data.code == 0){
                        this.list = res.data.data.records || []
                        this.total = res.data.data.total;
                    }
                }).catch(() => {
                    this.loading = false;
                });
            },
            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    ...this.$refs.needSift.getValue(),
                    current:1
                }
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            handleSelectionChange(val){
                this.selectList = val.map((item) =>{return item.id})
            },
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped  lang="less">
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>
